import { AxiosError } from 'axios';

const LIMIT_ERROR_MESSAGES: Record<string, string> = {
  UNAUTHORIZED: 'Please sign in to continue.',
  SUBSCRIPTION_REQUIRED: 'An active subscription is required. Check your email for access after payment.',
  SUBSCRIPTION_EXPIRED: 'Your subscription has expired. Renew to continue using WTI.',
  SUBSCRIPTION_SOFT_LOCKED:
    'Your grace period has ended. Renew to restore reports, downloads, and saved history. Training remains available.',
  PAYMENT_FAILED: 'Your payment is not active. Please update billing to restore access.',
  REPORT_LIMIT_REACHED: 'You have reached your report limit for this billing period.',
  SAVED_REPORT_LIMIT_REACHED: 'You have reached your saved report limit. Unsave a report or upgrade your plan.',
  FORBIDDEN: 'You do not have access to this resource.',
};

export function getLimitErrorMessage(error: unknown, fallback = 'Something went wrong. Please try again.'): string {
  const axiosError = error as AxiosError<{ code?: string; message?: string }>;
  const code = axiosError.response?.data?.code;
  const serverMessage = axiosError.response?.data?.message;

  if (code && LIMIT_ERROR_MESSAGES[code]) {
    return LIMIT_ERROR_MESSAGES[code];
  }

  if (serverMessage) {
    return serverMessage;
  }

  return fallback;
}
